<template>
    <main>
        <Background :image="backgroundImage" :setBackgroundImage="setBackgroundImage"/>

        <Title
                title="Ne verjemi velikim obljubam!"
                background="rgba(249, 150, 80, 0.8)"
                v-observe-visibility="observeTitle"/>

        <Floater :isVisible="showFloater"/>

        <Facts/>

        <Risk background="rgba(0, 0, 0, 0.8)">
            <p>Statistike kažejo, da nas na spletu, bolj kot hekerski napadi, morajo skrbeti različne spletne
                goljufije. Vabe, ki jih nastavljajo spletni goljufi, so zelo preproste - nizke cene in velike obljube,
                pa naj bodo super zaslužki, ugodni krediti, milijonske nagrade, zastonj vinjete za en sam »Like« ali
                neverjetno poceni izdelki.</p>

            <p class="highlight text-yellow">Goljufi si izmišljajo nove oblike spletnih prevar, vse pa imajo eno skupno
                značilnost - na eni točki želijo od tebe, da jim nakažeš denar!</p>

            <p>Zahtevajo, da nakažeš denar za najrazličnejše stroške, pošlješ kodo svoje PaySafe kartice, se
                včlaniš v SMS klub, ki te bo stal 20 evrov na mesec ali pa s kreditno kartico opraviš nakup v lažni
                trgovini. V vseh primerih bo denar dobil goljuf.</p>
        </Risk>

        <Actions background="rgba(249, 150, 80, 0.8)"/>

        <Footer
                title="Ne verjemi velikim obljubam!"
                background="rgb(255, 171, 120)"
                :gif="[ { src: require('../assets/ne-verjemi-velikim-obljubam.mp4'), type: 'video/mp4' }, { src: require('../assets/ne-verjemi-velikim-obljubam.webm'), type: 'video/webm' } ]"/>
    </main>
</template>

<script>
	// @ is an alias to /src
	import Title from '@/components/Title.vue'
	import Background from "../components/Background";

	export default {
		name: 'home',
		props: {
			cookiesAccepted: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			Background,
            Title,
			Facts: () => import('@/components/second-rule-sections/Facts.vue'),
			Risk: () => import('@/components/Risk.vue'),
			Actions: () => import('@/components/second-rule-sections/Actions.vue'),
			Footer: () => import("@/components/Footer.vue"),
			Floater: () => import("@/components/Floater"),
		},
		data() {
			return {
				showFloater: false,
                backgroundImage: require('../assets/drugo-pravilo.jpg'),
                setBackgroundImage: false,
			}
		},
		methods: {
			observeTitle(isVisible) {
				this.showFloater = !isVisible;
			},
		},
		watch: {
			cookiesAccepted: function () {
				this.$emit('updateHead');
			},
		},
		head: {
			script: function () {
				if (this.cookiesAccepted) {
					return [
						{
							type: 'text/javascript',
							src: 'https://www.googletagmanager.com/gtag/js?id=UA-102056350-6',
							async: true,
							body: false,
						},
						{
							type: 'text/javascript',
							i: `
                                window.dataLayer = window.dataLayer || [];
                                function gtag(){dataLayer.push(arguments);}
                                gtag('js', new Date());
                                gtag('config', 'UA-102056350-6');
                                `,
						},
					]
				}
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.setBackgroundImage = true;
			});
		},
	}
</script>

<style lang="scss">
</style>
